import { render, staticRenderFns } from "./AccessInfo.vue?vue&type=template&id=1c2f6138&"
import script from "./AccessInfo.vue?vue&type=script&lang=js&"
export * from "./AccessInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports